import { render, staticRenderFns } from "./screenChroma.vue?vue&type=template&id=30e6cf2c&scoped=true&"
import script from "./screenChroma.vue?vue&type=script&lang=js&"
export * from "./screenChroma.vue?vue&type=script&lang=js&"
import style0 from "./screenChroma.vue?vue&type=style&index=0&id=30e6cf2c&prod&lang=scss&scoped=true&"
import style1 from "./screenChroma.vue?vue&type=style&index=1&id=30e6cf2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6cf2c",
  null
  
)

export default component.exports